import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { setupIonicReact } from '@ionic/react';

/* Ionic-Basis */
import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';
import '@ionic/react/css/padding.css';

/* Leaflet vor unseren eigenen Stilen, damit wir überschreiben können */
import 'leaflet/dist/leaflet.css';

import './theme/variables.css';
import './styles.css';

import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';

// Überall dasselbe Erscheinungsbild - sonst sieht die App auf iOS und
// Android unterschiedlich aus.
setupIonicReact({ mode: 'ios' });

const container = document.getElementById('root');
if (!container) throw new Error('Wurzelelement #root fehlt.');

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
